import { TMSEquipmentType } from 'types/Load';
import { useThrowableSWR } from 'utils/fetcher';

type ReferenceTypesResponse = TMSEquipmentType[];

/**
 * Fetches MG-configured load reference types from
 * `/load/options/reference-types` (DrumkitReferenceTypes code table).
 */
export function useFetchReferenceTypes(tmsID: number) {
  const { data, error, isLoading } = useThrowableSWR<ReferenceTypesResponse>(
    tmsID ? `load/options/reference-types?tmsID=${tmsID}` : null,
    false
  );

  return {
    referenceTypes: data,
    isLoading,
    error,
  };
}
